import React from 'react'

import { cn } from '~/styled'

import { Tile } from '../tile/Tile'
import { SkeletonLoader } from './Skeleton'

export const SkeletonSubjectList = ({ className }: { className?: string }) => (
  <Tile
    className={cn(
      'p-2',
      'flex-row',
      'flex-wrap',
      'items-center',
      'justify-between',
      'gap-4',
      'w-full',
      className
    )}
  >
    <SkeletonLoader className="h-22 max-w-xl grow rounded-xl" />
    <SkeletonLoader className="size-10 shrink-0 rounded-md" />
  </Tile>
)
